import { lazy } from 'react'

export const WorkspacesDialog = lazy(
  () => import('@app/components/Risk/Workspaces/WorkspacesDialog'),
)

export const WorkspacesManager = lazy(
  () => import('@app/components/Risk/Workspaces/WorkspacesManager'),
)

export const WorkspacesCreate = lazy(
  () => import('@app/components/Risk/Workspaces/WorkspacesCreate'),
)

export const WorkspaceEdit = lazy(() =>
  import('@app/components/Risk/Workspaces/WorkspaceEdit').then((m) => ({
    default: m.WorkspaceEdit,
  })),
)

export const SavedWorkspacesPage = lazy(() =>
  import('@app/modules/Risk/Workspaces/pages/saved-workspaces.page').then((m) => ({
    default: m.SavedWorkspacesPage,
  })),
)

export const CreateEditWorkspace = lazy(() =>
  import('@app/modules/Risk/Workspaces/pages/create-edit-workspace.page').then((m) => ({
    default: m.CreateEditWorkspace,
  })),
)
